module.exports = __webpack_public_path__ + "img/Amazon Color.45e541bb.svg";